import { useMemo } from 'react'
import { useAppSelector } from '#app/store'

export function useFavoriteSets() {
  const favorites = useAppSelector((state) => state.userData.favorites)

  return useMemo(() => {
    const activeFavoriteSet = favorites.favoriteSets.find((set) => set.id === favorites.activeFavoriteSetId)
    return { ...favorites, activeFavoriteSet }
  }, [favorites])
}
